import Vue from 'vue'

Vue.filter('filename', url => {
  const index = url.lastIndexOf('/') + 1
  const filename = url.substr(index)
  // NOTE: Removing query params e.g. ?foo=bar&bar=111
  return filename.replace(/(#|\?).*?$/, '')
})
